<script lang="ts">
    import {exists} from 'shared/utils/custom-utils';
    import {getTabPagesMenuContext} from './menu/tab-pages-menu.context';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    const {selectedTab$} = getTabPagesMenuContext();

    $: component = $selectedTab$?.render?.component;
    $: props = $selectedTab$?.render?.props ?? {};
</script>

{#if exists(component)}
    <svelte:component this={component} {...props}/>
{:else}
    <IconedContent fillAvailableSpace icon="exclamation" orientation="vertical" align="center" justify="center">
        Nenachází se zde žádná záložka. Pravděpodobně nemáte práva.
    </IconedContent>
{/if}
